module.exports = __webpack_public_path__ + "img/ke.3db68a66.svg";